var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isMobile)?_c('email-success-desktop'):_c('email-success-mobile')
}
var staticRenderFns = []

export { render, staticRenderFns }